(function (Drupal, Swiper) {
  'use strict';

  Drupal.behaviors.frontendParagraphCarousel = {
    attach: function () {
      const bemBlock = 'paragraph-carousel';
      const carousel = document.querySelector('.' + bemBlock);
      const type = bemBlock.split('-')[0];

      const selectors = {
        paragraph: {
          parent: '__content',
          wrapper: '__slides',
          slide: '__slides-item'
        }
      };
      const slides = carousel.querySelectorAll('.' + bemBlock + selectors[type]['slide']);
      const wrapper = carousel.querySelector('.' + bemBlock + selectors[type]['wrapper']);
      const container = carousel.querySelector('.' + bemBlock + selectors[type]['parent']) ?? carousel;

      initSwiperClass(container, wrapper, slides);

      new Swiper(container, {
        loop: true,
        width: window.innerWidth,
        grabCursor: true,
        slidesPerView: 1,
        speed: 300,
        watchOverflow: true,
        autoplay: {
          delay: 3000
        }
      });
    }
  };

  function initSwiperClass(container, wrapper, slides) {
    container.classList.add('swiper-container');
    wrapper.classList.add('swiper-wrapper');
    slides.forEach((slide) => {
      slide.classList.add('swiper-slide');
    });
  }
})(Drupal, Swiper);
